const arrayUnion = (arr) => {
  return [...new Set([].concat(...arr))];
}

export { arrayUnion };